module.exports = __webpack_public_path__ + "media/images/athletes/2853-8f8e3222a9ccb9769a3318e4d55f43af.png";